import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getRoomCount, getWhereSearch } from './service';

export const useGetWhereSearch = (value: string) => {
  const [debounceValue, setDebounceValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(value);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return useQuery({
    queryKey: ['where', 'search', debounceValue],
    queryFn: () => getWhereSearch(debounceValue),
    placeholderData: (previousData) => previousData,
  });
};

export const useGetRoomCount = () => {
  return useQuery({
    queryKey: ['ROOM_COUNT'],
    queryFn: () => getRoomCount(),
  });
};
